module.exports = __webpack_public_path__ + "img/yellow2.9ad460b6.png";